<template>
  <div>
    <rabbey-toolbox
      :call-new="IsInRole(roles.GerenteRRHH) === true ? callNew : undefined"
      filterables
      @filter-search="onFilterSearch"
    />
    <el-select
      style="position: relative; bottom: 36px; left: 885px"
      v-model="activInac"
      size="mini"
      placeholder="Activos&Inactivos"
      clearable
      filterable
    >
      <el-option
        v-for="actEinac in ActiAndOul"
        :key="actEinac.Value"
        :label="actEinac.Label"
        :value="actEinac.Value"
      >
      </el-option>
    </el-select>
    <rabbey-table2
      ref="rTable"
      index-url="/api/Directions/GetDirecctionByCompanyMod"
      :paginate-from-api="false"
      :columns="columns"
      :actions="actions"
      :search="search"
      :default-params="getParams"
      @rtable-push-action="handleCommand"
    />
    <el-dialog
      title="Advertencia"
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <span> Desea {{ this.titleg }} esta gerencia? </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="onSubmit2(formAction)"
          >Aceptar</el-button
        >
      </span>
    </el-dialog>

    <el-drawer
      :title="title"
      :visible.sync="drawer"
      direccion="rtl"
      :before-close="handleBeforeClose"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col :span="24">
              <el-form
                ref="form"
                :model="form"
                label-position="left"
                size="mini"
                label-width="120px"
                :rules="rules"
              >
                <el-form-item label="Nombre" prop="Name">
                  <el-input
                    v-model="form.Name"
                    :disabled="formAction === 'view'"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="onSubmit(formAction)"
                    v-loading="drawerLoading"
                    v-if="formAction !== 'view'"
                    >{{ labelButton }}</el-button
                  >
                  <el-button @click="onCancel">Cancel</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </div>
</template>

<script>
import { formatDate } from "@/utils";

export default {
  name: "DirectionList",
  data() {
    return {
      search: "",
      loading_form: false,
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      activInac: true,
      activInacput: true,
      dialogVisible: false,
      titleg: " activar ",
      alldatatable: 2,
      optionId: 0,
      loading: false,
      departmentId: 2,
      productId: 0,
      serviceRequestTypeId: 0,
      technicalId: 0,
      items: [],
      drawer: false,
      title: "",
      labelButton: "Crear",
      drawerLoading: false,
      detail: {
        id: 0,
        clientCode: ""
      },
      formAction: "create",
      form: {
        Name: "",
        CompanySelected: ""
      },
      rules: {
        Name: [{ required: true, message: "Nombre es requerido" }],
        CompanySelected: [{ required: true, message: "Empresa es requerido" }]
      },
      columns: [
        {
          fixed: true,
          prop: "ID",
          name: "NO",
          width: 80
        },
        {
          prop: "Name",
          name: "Nombre",
          width: 1410
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-circle-check",
          label: "Activar",
          command: "activate",
          condition: (t) => t.isEneable === false
        },
        {
          icon: "el-icon-remove-outline",
          label: "Desactivar",
          command: "outline",
          condition: (t) => t.isEneable === true
        }
      ],
      ActiAndOul: [
        { Label: "Activos", Value: true },
        { Label: "Inactivos", Value: false },
        { Label: "Todas", Value: 3 }
      ]
    };
  },
  computed: {
    getParams() {
      if (this.activInac == 3) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.alldatatable = 3;
      } else if (this.activInac != 3) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.alldatatable = 2;
      }
      return {
        companyId: this.currentCompany,
        isEneable: this.activInac,
        CreatedBy: this.alldatatable
      };
    }
  },
  methods: {
    formatDate,
    onFilterSearch(s) {
      this.search = s;
    },
    callNew() {
      this.callForm("create");
    },
    getDataById(id) {
      const l = this.$loading({
        text: "Cargando datos"
      });
      this.$http
        .get(`/api/Directions/${id}`)
        .then((resp) => {
          this.form = resp.data;
          // console.log('deja verte data', this.form);
          this.drawer = true;
        })
        .catch((err) => {
          this.l2 = false;
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          l.close();
        });
    },
    onSubmit(action) {
      // validar el form
      this.$refs.form.validate((valid) => {
        if (valid) {
          // Peticion de creacion
          if (action === "create") {
            this.loading_form = true;
            this.drawerLoading = true;
            this.$http
              .post("/api/Directions", {
                Name: this.form.Name,
                CompanySelected: this.currentCompany
              })
              .then(() => {
                this.drawer = false;
                this.drawerLoading = false;
                this.message({
                  type: "success",
                  message: "Creado"
                });
                this.columns();
              })
              .catch(() => {
                this.message.error("Erro!");
                this.loading_form = false;
              })
              .finally(() => {
                this.loading_form = false;
                this.drawerLoading = false;
                this.$refs.rTable.initialTable();
                this.form = {};
              });
          } else if (action === "edit") {
            this.loading_form = true;
            this.drawerLoading = true;
            this.$http
              .put(`/api/Directions/${this.form.Id}`, this.form)
              .then(() => {
                // console.log("Directions from id",this.form.Id)
                this.$message({
                  type: "success",
                  message: "Actualizado"
                });
              })
              .catch(() => {
                this.message.error("Erro!");
              })
              .finally(() => {
                this.loading_form = false;
                this.drawerLoading = false;
                this.drawer = false;
                this.drawerLoading = false;
                this.form = {};
                this.$refs.rTable.initialTable();
              });
          }
        } else {
          this.drawer = true;
          return false;
        }
      });
    },
    onSubmit2(action) {
      if (action === "outline") {
        this.loading_form = true;
        let params = {
          isEneable: this.activInacput
        };
        this.$http
          .put(`/api/Directions/putactivate${this.optionId}`, params)
          .then(() => {
            if (this.activInacput == true) {
              this.$message({
                type: "success",
                message: "Direccion de Gerencia Activada Correctamente"
              });
            } else {
              this.$message({
                type: "success",
                message: "Direccion de Gerencia Desactivada Correctamente"
              });
            }
            //  console.log('klk incac boool',bit );
            //  console.log('klk id col', id);
          })
          .catch(() => {
            this.message.error("Erro!");
          })
          .finally(() => {
            this.loading_form = false;
            this.dialogVisible = false;
            this.form = {};
            this.$refs.rTable.initialTable();
          });
      } else if (action === "activate") {
        this.loading_form = true;
        let params = {
          isEneable: this.activInacput
        };
        this.$http
          .put(`/api/Directions/putactivate${this.optionId}`, params)
          .then(() => {
            if (this.activInacput == true) {
              this.$message({
                type: "success",
                message: "Direccion de Gerencia Activada Correctamente"
              });
            } else {
              this.$message({
                type: "success",
                message: "Direccion de Gerencia Desactivada Correctamente"
              });
            }
            //  console.log('klk incac boool',bit );
            //  console.log('klk id col', id);
          })
          .catch(() => {
            this.message.error("Erro!");
          })
          .finally(() => {
            this.loading_form = false;
            this.dialogVisible = false;
            this.form = {};
            this.$refs.rTable.initialTable();
          });
      }
    },
    handleBeforeClose(done) {
      this.$refs.form.resetFields();
      done();
    },
    callForm(type) {
      if (type === "create") {
        this.form = {
          Name: "",
          CompanySelected: ""
        };
        this.title = `Crear Dirección`;
        this.formAction = "create";
        this.drawer = true;
      }
    },
    onCancel() {
      this.form = {};
      this.drawer = false;
      this.drawerLoading = false;
    },
    handleCommand(option) {
      const isValid = this.IsInRole(this.roles.GerenteRRHH);
      if (
        (option.command === "edit" && !isValid) ||
        (option.command === "view" &&
          !isValid &&
          option.command === "activate" &&
          !isValid &&
          option.command === "outline" &&
          !isValid)
      ) {
        this.$message.warning("Lo sentimos usted no tiene acceso");
      } else {
        switch (option.command) {
          case "view": {
            this.title = `Ver - ${option.row.Name}`;
            this.formAction = "view";
            this.getDataById(option.row.ID);

            break;
          }
          case "edit": {
            this.title = `Editar - ${option.row.Name}`;
            this.labelButton = "Editar";
            this.formAction = "edit";
            this.getDataById(option.row.ID);

            break;
          }
          case "activate": {
            this.dialogVisible = true;
            this.titleg = "Activar";
            this.formAction = "activate";
            this.activInacput = true;
            this.optionId = option.row.ID;
            // console.log('klk row id',this.optionId);
            // alert("hola perro dialogo sal")
            break;
          }
          case "outline": {
            this.dialogVisible = true;
            this.titleg = "Desactivar";
            this.formAction = "outline";
            this.activInacput = false;
            this.optionId = option.row.ID;
            // console.log('klk row id',this.optionId);
            // this.managementcha( this.activInacput)
            // alert("hola perro dialogo sal")
            break;
          }
          default:
            this.formAction = "create";
            break;
        }
      }
    }
  }
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #3c3c3c;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
